// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import {
    Box, Link, Typography
} from '@mui/material';

// TODO: Import MUI icon

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import BoxSubPage from '../Common/BoxSubPage';

const P202501240736 = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component P202501240736 Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define reference

    // TODO: Define variable

    // TODO: Define event

    // TODO: Define function

    // TODO: Return component

    return (
        <BoxSubPage
            disableMenu={true}
            disableSubtitle={true}
            id="P202501240736"
            title="師生投入匹克球活動 走在國際最前線"
        >
            <Typography variant="body1">匹克球在全球迅速發展，成為受歡迎的休閒和競技運動。許多國家都設立了相關比賽和聯盟，推廣普及匹克球運動，吸引各年齡層參與，並促進社區互動和健康生活方式。</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Box component="img" src="https://www.pohtyh.edu.hk/Files/Pages/P202501240736/4.jpg" sx={{ width: 0.8 }} />
            </Box>
            <Typography sx={{ textAlign: 'center' }} variant="body1">我校積極推廣匹克球運動</Typography>
            <Typography sx={{ fontWeight: 'bold', mt: 2 }} variant="body1">全港首兩位老師考護「匹克球社會指導員訓練」資格</Typography>
            <Typography variant="body1">本校也不甘示弱，積極推廣匹克球在港的普及和發展，更在中學界擔任了先鋒領導地位，本校李紹維老師、劉得聰老師去年已前往北京進行「匹克球社會指導員訓練」，更是全港首兩位考獲相關證書的老師。</Typography>
            <Link
                href="https://www.pohtyh.edu.hk/Files/Pages/P202501240736/1.pdf"
                rel="noreferrer"
                target="_blank"
                sx={{ mt: 1 }}
                variant="body1"
            >
                相關報導請點擊此處閱讀
            </Link>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Box component="img" src="https://www.pohtyh.edu.hk/Files/Pages/P202501240736/1.jpg" sx={{ width: 0.8 }} />
            </Box>
            <Box sx={{display:'flex',justifyContent:'center',}} >
                <Typography sx={{ width: 0.8 }} variant="body1">李紹維老師(左二)及劉得聰老師(左四)早前赴京參與首屆中小學教師匹克球社會指導員培訓班，獲得國家級運動健將林雅鳴(中)親身培訓指導</Typography>
            </Box>
            <Typography sx={{ fontWeight: 'bold', mt: 2 }} variant="body1">與北京市戰友結盟</Typography>
            <Typography variant="body1">為進一步推廣匹克球在港發展，本校校長早於去年八月拜訪北京市海淀外國語雙優運動學院，並與該校胡雄一校長進行了深入的交流和討論。雙方同意通過合作，在各自的領域推廣匹克球運動及推動匹克球發展，並促進兩地教育和文化的交流與融合。去年十一月底，我校更邀請了北京市海淀外國語雙優運動學院師生到本校進行交流活動，並締結成姊妹學校。</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Box component="img" src="https://www.pohtyh.edu.hk/Files/Pages/P202501240736/2.jpg" sx={{ width: 0.8 }} />
            </Box>
            <Typography sx={{ textAlign: 'center' }} variant="body1">本校師生與北京市海淀外國語雙優運動學院師生進行交流</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Box component="img" src="https://www.pohtyh.edu.hk/Files/Pages/P202501240736/3.jpg" sx={{ width: 0.8 }} />
            </Box>
            <Typography sx={{ textAlign: 'center' }} variant="body1">我校與北京市海淀外國語雙優運動學院締結為姊妹學校</Typography>
            <Typography sx={{ fontWeight: 'bold', mt: 2 }} variant="body1">新興運動「匹克球」如何走進全球多個社區？</Typography>
            <Typography variant="body1">匹克球可謂「網球」、「乒乓球」及「羽毛球」等拍類運動的混合體，近年在世界各地火速冒起，在北美洲特別流行。想知道匹克球如何迅速走入全球多個社區，而本校又在推廣匹克球的進程中，擔任了什麼角色，不妨閱讀一下以下文章。</Typography>
            <Link
                href="https://news.mingpao.com/ins/%e9%ab%94%e8%82%b2/article/20250117/s00006/1737110212202"
                rel="noreferrer"
                target="_blank"
                sx={{ mt: 1 }}
                variant="body1"
            >
                明報：匹克球品牌進駐市區　分址定位各不同　冀多方面推動發展
            </Link>
            <Link
                href="https://www.wenweipo.com/a/202501/17/AP678a48d6e4b0de8a9318fd06.html"
                rel="noreferrer"
                target="_blank"
                sx={{ mt: 1 }}
                variant="body1"
            >
                文匯網：Bay Pickle力拓大灣區匹克球市場  港半年開3舖
            </Link>
            <Link
                href="https://www.scmp.com/postmag/culture/article/3294035/grandmas-game-taking-hong-kong-and-all-ages-storm"
                rel="noreferrer"
                target="_blank"
                sx={{ mt: 1 }}
                variant="body1"
            >
                SCMP: This ‘grandma’s game’ is taking Hong Kong – and all ages – by storm
            </Link>
        </BoxSubPage>
    );
}

export default P202501240736;